// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== MAIN CONTAINER ==================== */

.vs-container {
    width: 100%;
    height: auto;
    min-height: 500px;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    padding: 1rem;
    box-sizing: border-box;
  }
  
  /* ==================== PRIMARY SECTION (DYNAMIC WIDTH) ==================== */
  
  .vs-primary-section {
    flex: 1 1;
    min-width: 0; /* Allow shrinking */
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    padding: 1rem;
  }
  
  .vs-primary-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .vs-primary-media {
    max-width: 100%;
    max-height: 1000px;
    width: auto;
    height: 1000px;
    object-fit: cover;
    display: block;
    border-radius: 8px;
    transition: transform 0.3s ease;
  }
  
  .vs-primary-media:hover {
    transform: scale(1.02);
  }
  
  .vs-primary-audio {
    width: 100%;
    max-width: 500px;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
  }
  
  .vs-primary-audio audio {
    width: 100%;
  }
  
  /* ==================== SECONDARY SECTION (FIXED WIDTH) ==================== */
  
  .vs-secondary-section {
    flex-shrink: 0;
    width: 250px;
    height: auto;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    position: relative;
  }
  
  /* ==================== SCROLL BUTTONS ==================== */
  
  .vs-scroll-button {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: none;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
  }
  
  .vs-scroll-button:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
  }
  
  .vs-scroll-button:active {
    transform: scale(0.95);
  }
  
  .vs-chevron-icon {
    width: 24px;
    height: 24px;
  }
  
  /* ==================== THUMBNAILS WRAPPER ==================== */
  
  .vs-thumbnails-wrapper {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
    padding: 0.5rem;
    width: 100%;
    
    /* Hide scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .vs-thumbnails-wrapper::-webkit-scrollbar {
    display: none;
  }
  
  /* ✅ DYNAMIC THUMBNAIL SIZING (1, 2, or 3 items) */
  
  /* Single thumbnail - Takes full height */
  .vs-thumbnails-1 .vs-thumbnail-item {
    height: 100%;
    min-height: 300px;
    max-height: 450px;
  }
  
  /* Two thumbnails - Each takes ~50% minus gap */
  .vs-thumbnails-2 .vs-thumbnail-item {
    height: calc((100% - 12px) / 2);
    min-height: 180px;
    max-height: 250px;
  }
  
  /* Three thumbnails - Each takes ~33% minus gaps */
  .vs-thumbnails-3 .vs-thumbnail-item {
    height: calc((100% - 24px) / 3);
    min-height: 140px;
    max-height: 180px;
  }
  
  /* Default thumbnail item */
  .vs-thumbnail-item {
    flex-shrink: 0;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    position: relative;
    background: rgba(0, 0, 0, 0.05);
  }
  
  .vs-thumbnail-item:hover {
    transform: scale(1.05);
    border-color: rgba(0, 0, 0, 0.2);
    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.15);
  }
  
  .vs-thumbnail-selected {
    border: 3px solid #6c757d !important;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2),
                0 0.5rem 1.5rem rgba(0, 0, 0, 0.2) !important;
    transform: scale(1.02);
  }
  
  .vs-thumbnail-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }
  
  /* ==================== THUMBNAIL VIDEO ==================== */
  
  .vs-thumbnail-video-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .vs-thumbnail-video-wrapper video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .vs-video-play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 3rem;
    height: 3rem;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.25rem;
    pointer-events: none;
  }
  
  /* ==================== THUMBNAIL AUDIO ==================== */
  
  .vs-thumbnail-audio {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    pointer-events: none;
  }
  
  .vs-audio-icon {
    font-size: 3rem;
  }
  
  .vs-audio-label {
    font-size: 0.875rem;
    font-weight: bold;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  /* ==================== DETAIL POPUP OVERLAY ==================== */
  
  .vs-detail-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  .vs-detail-modal {
    position: relative;
    display: flex;
    width: 90vw;
    max-width: 1200px;
    height: 85vh;
    max-height: 800px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);
  }
  
  .vs-detail-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.3s ease;
  }
  
  .vs-detail-close:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: scale(1.1);
  }
  
  /* ==================== DETAIL MEDIA (LEFT) ==================== */
  
  .vs-detail-media {
    flex: 1.5 1;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  .vs-detail-media-content {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  
  .vs-detail-audio-wrapper {
    width: 80%;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
  }
  
  .vs-detail-audio-wrapper audio {
    width: 100%;
  }  `, "",{"version":3,"sources":["webpack://./src/components/common/VerticalScroll/verticalScroll.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA,8EAA8E;;EAE9E;IACE,SAAO;IACP,YAAY,EAAE,oBAAoB;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;IAC7D,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA,6DAA6D;;EAE7D;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iEAAiE;;EAEjE;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,WAAW;;IAEX,mBAAmB;IACnB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA,kDAAkD;;EAElD,yCAAyC;EACzC;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,+CAA+C;EAC/C;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,kDAAkD;EAClD;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,8CAA8C;EAChD;;EAEA;IACE,oCAAoC;IACpC;6DACyD;IACzD,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oBAAoB;EACtB;;EAEA,8DAA8D;;EAE9D;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,8DAA8D;;EAE9D;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,6DAA6D;IAC7D,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,mEAAmE;;EAEnE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA,kEAAkE;;EAElE;IACE,WAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,6DAA6D;IAC7D,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb","sourcesContent":["/* ==================== MAIN CONTAINER ==================== */\n\n.vs-container {\n    width: 100%;\n    height: auto;\n    min-height: 500px;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    background: rgba(0, 0, 0, 0.02);\n    border-radius: 12px;\n    padding: 1rem;\n    box-sizing: border-box;\n  }\n  \n  /* ==================== PRIMARY SECTION (DYNAMIC WIDTH) ==================== */\n  \n  .vs-primary-section {\n    flex: 1;\n    min-width: 0; /* Allow shrinking */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.03);\n    border-radius: 12px;\n    overflow: hidden;\n    position: relative;\n    padding: 1rem;\n  }\n  \n  .vs-primary-content {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n  \n  .vs-primary-media {\n    max-width: 100%;\n    max-height: 1000px;\n    width: auto;\n    height: 1000px;\n    object-fit: cover;\n    display: block;\n    border-radius: 8px;\n    transition: transform 0.3s ease;\n  }\n  \n  .vs-primary-media:hover {\n    transform: scale(1.02);\n  }\n  \n  .vs-primary-audio {\n    width: 100%;\n    max-width: 500px;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 12px;\n  }\n  \n  .vs-primary-audio audio {\n    width: 100%;\n  }\n  \n  /* ==================== SECONDARY SECTION (FIXED WIDTH) ==================== */\n  \n  .vs-secondary-section {\n    flex-shrink: 0;\n    width: 250px;\n    height: auto;\n    min-height: 500px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    position: relative;\n  }\n  \n  /* ==================== SCROLL BUTTONS ==================== */\n  \n  .vs-scroll-button {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border: none;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    z-index: 10;\n  }\n  \n  .vs-scroll-button:hover {\n    background: rgba(0, 0, 0, 0.8);\n    transform: scale(1.1);\n  }\n  \n  .vs-scroll-button:active {\n    transform: scale(0.95);\n  }\n  \n  .vs-chevron-icon {\n    width: 24px;\n    height: 24px;\n  }\n  \n  /* ==================== THUMBNAILS WRAPPER ==================== */\n  \n  .vs-thumbnails-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    padding: 0.5rem;\n    width: 100%;\n    \n    /* Hide scrollbar */\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .vs-thumbnails-wrapper::-webkit-scrollbar {\n    display: none;\n  }\n  \n  /* ✅ DYNAMIC THUMBNAIL SIZING (1, 2, or 3 items) */\n  \n  /* Single thumbnail - Takes full height */\n  .vs-thumbnails-1 .vs-thumbnail-item {\n    height: 100%;\n    min-height: 300px;\n    max-height: 450px;\n  }\n  \n  /* Two thumbnails - Each takes ~50% minus gap */\n  .vs-thumbnails-2 .vs-thumbnail-item {\n    height: calc((100% - 12px) / 2);\n    min-height: 180px;\n    max-height: 250px;\n  }\n  \n  /* Three thumbnails - Each takes ~33% minus gaps */\n  .vs-thumbnails-3 .vs-thumbnail-item {\n    height: calc((100% - 24px) / 3);\n    min-height: 140px;\n    max-height: 180px;\n  }\n  \n  /* Default thumbnail item */\n  .vs-thumbnail-item {\n    flex-shrink: 0;\n    width: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: all 0.3s ease;\n    position: relative;\n    background: rgba(0, 0, 0, 0.05);\n  }\n  \n  .vs-thumbnail-item:hover {\n    transform: scale(1.05);\n    border-color: rgba(0, 0, 0, 0.2);\n    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.15);\n  }\n  \n  .vs-thumbnail-selected {\n    border: 3px solid #6c757d !important;\n    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2),\n                0 0.5rem 1.5rem rgba(0, 0, 0, 0.2) !important;\n    transform: scale(1.02);\n  }\n  \n  .vs-thumbnail-media {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    pointer-events: none;\n  }\n  \n  /* ==================== THUMBNAIL VIDEO ==================== */\n  \n  .vs-thumbnail-video-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .vs-thumbnail-video-wrapper video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .vs-video-play-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 3rem;\n    height: 3rem;\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 1.25rem;\n    pointer-events: none;\n  }\n  \n  /* ==================== THUMBNAIL AUDIO ==================== */\n  \n  .vs-thumbnail-audio {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    pointer-events: none;\n  }\n  \n  .vs-audio-icon {\n    font-size: 3rem;\n  }\n  \n  .vs-audio-label {\n    font-size: 0.875rem;\n    font-weight: bold;\n    color: white;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  /* ==================== DETAIL POPUP OVERLAY ==================== */\n  \n  .vs-detail-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.95);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    animation: fadeIn 0.3s ease;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  \n  .vs-detail-modal {\n    position: relative;\n    display: flex;\n    width: 90vw;\n    max-width: 1200px;\n    height: 85vh;\n    max-height: 800px;\n    background: white;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);\n  }\n  \n  .vs-detail-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    width: 40px;\n    height: 40px;\n    background: rgba(0, 0, 0, 0.7);\n    border: none;\n    border-radius: 50%;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n    transition: all 0.3s ease;\n  }\n  \n  .vs-detail-close:hover {\n    background: rgba(0, 0, 0, 0.9);\n    transform: scale(1.1);\n  }\n  \n  /* ==================== DETAIL MEDIA (LEFT) ==================== */\n  \n  .vs-detail-media {\n    flex: 1.5;\n    background: #000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n  }\n  \n  .vs-detail-media-content {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  \n  .vs-detail-audio-wrapper {\n    width: 80%;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 12px;\n  }\n  \n  .vs-detail-audio-wrapper audio {\n    width: 100%;\n  }  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
